import React, { Fragment } from 'react'

import OutlineContainer from './components/OutlineContainer'

import debounce from 'lodash/debounce'

const DEBOUNCE_UPDATE = 1000

export default ({ utils: { createStore } }) => () => {
  const store = createStore({
    changes: 0,
  })

  const updateChangesCount = debounce(() => {
    const previousChangesCount = store.getItem('changes') || 0
    store.updateItem('changes', previousChangesCount + 1)
  }, DEBOUNCE_UPDATE)

  return [
    {
      onConstruct: (editor, next) => {
        updateChangesCount()
        return next()
      },
      onChange: (editor, next) => {
        updateChangesCount()
        return next()
      },
      renderEditor(props, editor, next) {
        return (
          <Fragment>
            {next()}
            <OutlineContainer editor={editor} pluginStore={store} />
          </Fragment>
        )
      },
    },
  ]
}
